import { render, staticRenderFns } from "./PeriodoSelect.vue?vue&type=template&id=253b6fea&"
import script from "./PeriodoSelect.vue?vue&type=script&lang=js&"
export * from "./PeriodoSelect.vue?vue&type=script&lang=js&"
import style0 from "./PeriodoSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports